import React, { useEffect } from 'react'
import ChatBox from './components/ChatBox'
import "./App.css"

import { useDispatch, useSelector } from 'react-redux';
import Home from './Home';

function App() {
    const dispatch = useDispatch()
    const socket = useSelector(state => state.socket)
    const username = useSelector(state => state.username)

    useEffect(() => {
        if (socket) {
            socket.on('message', ({ user, message , date}) => {
                dispatch({ type: "NEW_MESSAGE", payload: { user, message , date } })
            })
            socket.on('getallusers', ({name}) => {
                dispatch({ type: "GET_USERS", payload: { name } })
            })
            socket.on('addnewgroup' , ({name , info})=>{
                dispatch({type : "ADD_NEW_GROUP", payload : {name , info}})
            })
        }
    }, [socket])

    const content = (username.length === 0) ? <Home /> : <ChatBox />
    return (
        <div>
            {content}
        </div>
    )
}

export default App